// eslint-disable-next-line no-unused-vars
import { MealBreakFormDataDTO } from '@/models/booking/timeEntries/mealBreakFormDataDTO'
import {
  MealBreakEndFormRequestModel,
  ReducedMealBreakReasonRequestModel,
  TimeEntryMealBreakEndRequest,
} from '@/models/booking/timeEntries/requests/timeEntryMealBreakEndRequest'

/**
 * Compiles payload for end meal break request.
 * @param {{bookingId: number, formData: MealBreakFormDataDTO|null}} payload
 * @returns {TimeEntryMealBreakEndRequest}
 */
export default function ({ bookingId, formData }) {
  let form = null

  if (formData) {
    form = new MealBreakEndFormRequestModel({
      reducedMealBreak: new ReducedMealBreakReasonRequestModel({
        option: formData.reducedMealBreak.option,
        value: formData.reducedMealBreak.value,
      }),
    })
  }

  return new TimeEntryMealBreakEndRequest({
    bookingId,
    form,
  })
}
